import { createSelector } from '@reduxjs/toolkit';

import { selectFlags } from './select-flags';

export const shouldCollectZipCode = createSelector(
  selectFlags,
  (flags) => flags['collect-zip-code'] as boolean
);
